import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('sedes'), opciones);
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`sedes/${id}`));
  },
  async update(id, data, opciones = { params: {} }) {
    return await axiosIns.patch(obtenerUrlAPIComisiones(`sedes/${id}`), data, opciones);
  },
  async findAllByUnidadesNegociosIds(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('sedes/unidades-negocios-ids'), opciones);
  },
};
